import React from "react";
import Tooltip from "rc-tooltip";
import moment from "moment";
import { IconList, IconItem } from "./style.ts";

const JobIcons = ({
  company_name: companyName,
  position_types: positionTypes,
  pay_rate: payRate,
  created_at: createdAt,
  telecommuting_position: telecommutingPosition,
  keywords,
  address,
  travel,
  city,
  state,
}) => (
  <IconList>
    {companyName && (
      <IconItem>
        <Tooltip placement="top" trigger={["click"]} overlay="Company">
          <>
            <i className="fa fa-building" alt="company" />
            {companyName}
          </>
        </Tooltip>
      </IconItem>
    )}
    {keywords && keywords.length > 0 && (
      <IconItem>
        <Tooltip placement="top" trigger={["click"]} overlay="Keywords">
          <>
            <i className="fa fa-wrench" alt="keywords" />
            {keywords.map((x) => x.name).join(", ")}
          </>
        </Tooltip>
      </IconItem>
    )}
    {positionTypes.length ? (
      <IconItem>
        <Tooltip placement="top" trigger={["click"]} overlay="Position Type">
          <>
            <i className="fa fa-briefcase" aria-hidden="true" />
            {positionTypes.map((p, i) =>
              i !== positionTypes.length - 1 ? `${p.name}, ` : p.name
            )}
          </>
        </Tooltip>
      </IconItem>
    ) : null}
    {payRate && (
      <IconItem>
        <Tooltip placement="top" trigger={["click"]} overlay="Pay Rate">
          <>
            <i className="fa fa-money" alt="pay rate" />${payRate}/hr
          </>
        </Tooltip>
      </IconItem>
    )}
    {(city || state) && (
      <IconItem>
        <Tooltip placement="top" trigger={["click"]} overlay="Location">
          <>
            <i className="fa fa-location-arrow" alt="address" />
            {address({ city, state })}
          </>
        </Tooltip>
      </IconItem>
    )}
    <IconItem>
      <Tooltip placement="top" trigger={["click"]} overlay="Time since posted">
        <>
          <i className="fa fa-calendar" alt="calendar" />
          Posted&nbsp; {moment(createdAt).fromNow()}
        </>
      </Tooltip>
    </IconItem>
    {travel && (
      <IconItem>
        <Tooltip placement="top" trigger={["click"]} overlay="Travel">
          <>
            <i className="fa fa-plane" alt="travel" />
            {travel === "f" ? "0%" : travel}
          </>
        </Tooltip>
      </IconItem>
    )}
    {telecommutingPosition === "Yes" && (
      <IconItem>
        <Tooltip placement="top" trigger={["click"]} overlay="Remote position">
          <>
            <i className="fa fa-desktop" alt="telecomuting position" />
            Remote work
          </>
        </Tooltip>
      </IconItem>
    )}
  </IconList>
);

export default JobIcons;
